module.exports = __webpack_public_path__ + "img/info4.8f41e985.svg";